<template>
  <div id="onlineschoollist" ref="anchor">
    <div class="loader" v-if="loadingBankSoal" >
        <v-progress-circular
        :size="70"
        :width="7"
        color="white"
        indeterminate
        style="position: fixed;top: 50%;"
      ></v-progress-circular>
      </div>
    <v-container :class="'info-detail-sbs'">
          <v-layout row wrap>
        <v-flex x12>
          <v-btn small icon dark @click="$router.push('/video/'+ $route.params.id+'/bab/')">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs10 offset-xs1>
          <span class="white--text">Bab</span>
        </v-flex>
        <v-flex xs10 offset-xs1>
          <h2 class="white--text">{{subject}}</h2>
        </v-flex>
      </v-layout>
    </v-container>

    <v-layout row wrap>
      <v-flex xs12>
          <search-video-component ref="searchvideo"></search-video-component>
      </v-flex>
    </v-layout>

    <v-container v-if="videos.length > 0">
      <v-layout row wrap v-for="(item,index) in videos" v-bind:key="index" @click="playVideo(item)" style="cursor:pointer;">
        <v-flex xs4 style="position:relative;">
          <img alt="image-alt" :src="item.thumbnail"/>
          <div class="duration">{{convertSecond(item.duration)}}</div>
        </v-flex>
        <v-flex xs8>
          <p style="font-weight:bold; font-size:15px; padding:1em;">{{item.title}}</p>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 style="display:flex; justify-content:center;">
          <v-progress-circular
            v-if="loader"
            indeterminate
            :size="30"
            color="primary"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-if="videos.length > 1 && !hideLoadMore">
        <v-flex xs12 style="display:flex;justify-content:center;">
          <v-btn v-if="!endPage" flat small dark color="#10aa85" @click="loadMoreVideo()">Lihat Lebih Banyak</v-btn>
          <v-btn v-if="endPage" flat small dark color="#10aa85" @click="loadLessVideo()">Lihat Lebih Sedikit</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container >
      <v-layout row wrap v-if="subbabs.length > 0">
        <v-flex xs12>
          <p style="font-weight:bold; color:#33aadb;">Sub-Bab </p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 v-for="(item,index) in subbabs" v-bind:key="index">
          <h3>{{item.subbab_title}}</h3>
          <v-container>
            <v-layout row wrap v-for="(subitem,subindex) in item.subbab_videos" v-bind:key="subindex" style="cursor:pointer;" @click="playVideo(subitem)">
              <v-flex xs1>
                <v-icon color="primary">play_circle</v-icon>
              </v-flex>
              <v-flex xs10>
                {{subitem.title}}
                <p>{{convertSecond(subitem.duration)}}</p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>

      <v-layout row wrap style="background-color:#fff6d7; padding:2em;">
        <v-flex xs3>
          <img alt="image-alt" src="@/assets/icon/ic_banksoal.png"/>
        </v-flex>
        <v-flex xs9 style="display:flex;justify-content: center;flex-flow: inherit;">
          <p>Kamu mau latihan soal-soal seputar bab ini?</p>
          <v-btn small round type="button" dark color="#10aa85" @click="generateItemBank()">Yuk Latihan !</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<style>
  .filter {
    position: fixed;
    bottom:0;
    left: 0;
    right: 0;
    width: 100%;
    display:flex;
    justify-content:center;
    margin-bottom: 10px;
  }
  .loader {
    z-index: 999;
    position: fixed !important;
    height: 100%;
    min-height: 100vh;
    max-width:480px;
    width:100%;
    top:0;
    opacity: 0.5;
    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .filter-btn {
    padding: 15px;
    display:flex;
    align-items:center;
    box-shadow:0px 3px 5px 0px rgba(0,0,0,0.75);
  }
  .list-filter {
    padding:15px; background-color:#f7f7f7;
  }
  .video-title {
    margin-top: 10px; padding-left: 10px;
  }
  .duration {
    background: black; color: white; position:absolute; right: 5px; bottom: 10px; padding: 2px; border-radius: 3px;
  }
  .video-card {
    margin:20px;margin-top: 10px; margin-bottom:0px; padding:10px;border-radius: 8px;
  }
  .v-text-field__details {
    display:none;
  }
</style>

<script>
// import { mapGetters } from 'vuex'
import SearchVideoComponent from '../../components/SearchVideo/SearchVideoComponent.vue'
import InfiniteLoading from 'vue-infinite-loading'
// import moment from 'moment/src/moment'
/* eslint-disable */
export default {
  name: 'online-school-list-feature-component',
  data () {
    return {
      subject: null,
      babs: [],
      videos: [],
      subbabs: [],
      page: 1,
      loader: false,
      endPage: false,
      loadingBankSoal: false,
      selectedMapel: null,
      selectedBab: null,
      selectedSubBab: '',
      hideLoadMore: false
    }
  },
  components: {
    'search-video-component': SearchVideoComponent,
    InfiniteLoading
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.fetchData()
      }
    }
  },
  methods: {
    fetchBab() {
      var context = this
      setTimeout(() => {
        this.subject = this.$store.state.video.video_bab.title

        var param = {
          bab_id: this.$route.params.babid,
        }
        this.$store.dispatch('funcGetVTopic', param).then((response) => {
            this.videos = response.data.bab_videos
            this.subbabs = response.data.subbabs
            if(this.$store.state.video.video_bab.video_count <= 2) this.hideLoadMore = true
          this.loader = false
        }).catch(err => {
          this.loader = false
          if(err) console.log(err)
        })
      }, 500)
    },
    toVideo(data) {
      this.$store.commit('mutVideoBab', data)
      this.$router.push('/video/' + this.$route.params.id + '/bab/'+ data.id )
    },
    convertSecond(time) {
      var hrs = ~~(time / 3600);
      var mins = ~~((time % 3600) / 60);
      var secs = ~~time % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = "";

      if (hrs > 0) {
          ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
      }

      ret += "" + mins + ":" + (secs < 10 ? "0" : "");
      ret += "" + secs;
      return ret;
    },
    loadMoreVideo(){
      this.loader = true

      setTimeout(() => {
        this.subject = this.$store.state.video.video_bab.title

        var param = {
          bab_id: this.$route.params.babid,
          page: this.page
        }

        if(this.videos.length == 2) this.videos = []

        this.$store.dispatch('funcGetVTopicMore', param).then((response) => {
            if(response.data.length > 0) {
              this.videos.push(...response.data)
            }
            if(response.data.length == 10) {
              this.page += 1
            } else if(response.data.length < 10){
              this.endPage = true
            }
            this.loader = false
        }).catch(err => {
          this.loader = false
          if(err) console.log(err)
        })
      }, 500)
    },
    loadLessVideo(){
      this.page = 1
      this.endPage = false
      this.fetchBab()
    },
    playVideo(item) {
      this.$router.push('/video/'+ this.$route.params.id+'/bab/'+ this.$route.params.babid+'/play/'+ + item.id)
    },
    generateItemBank(){
      if (this.premiumCheck()) {
        this.toSoal()
      } else {
        this.$store.commit('setFeatureProhibited', [])
      }
    },
    toSoal () {
      this.loadingBankSoal = true
      const dataBab = this.$store.state.video

      this.selectedMapel = {
        mapel_code: dataBab.video_mapel.code,
        mapel_name: dataBab.video_mapel.nama,
        mapel_id: dataBab.video_mapel.id,
        mapel_picture: dataBab.video_mapel.picture
      }

      this.selectedBab = {
        bab_id: dataBab.video_bab.id,
        bab_code: dataBab.video_bab.kode,
        bab_name: dataBab.video_bab.title
      }

      this.$store.dispatch('funcGetItems',
        {
          mapel_code: this.selectedMapel.mapel_code,
          bab_code: this.selectedBab.bab_code,
          sub_bab_code: this.selectedSubBab ? this.selectedSubBab.sub_bab_code : ''
        }).then(response => {
        // if (this.sessionId == '') this.sessionId = response.data.session_id
        this.creatingSession(this.selectedMapel, this.selectedBab, this.selectedSubBab)
      }).catch(error => {
        // console.log(error)
        this.loadingBankSoal = false
        this.emptyItem = true
      })
      
    },
    premiumCheck(){
      this.reloadScope = true
      var context = this
        context.$store.dispatch('funcDecoding')
        var scopes = JSON.parse(sessionStorage.getItem('scopes_expired'))
        var currentTime = context.$store.state.tryout.serverTime
        var premium = scopes.find(function(element){
            return element.scope_name === 'app_itembank'
          })
        if(premium && premium.scope_expired > currentTime) {
          return true
        } else {
          return false
        }
    },
    creatingSession (mapel, bab, subbab){
      var req = {
        mapel_id : mapel.mapel_code,
        mapel_name : mapel.mapel_name,
        mapel_picture : mapel.mapel_picture,
        bab_id : bab.bab_code,
        bab_name : bab.bab_name
      }
      this.$store.dispatch('funcSetSession', req).then(response => {
        localStorage.setItem('session_item_bank', response.data.session_id)
        this.setLastTopics(mapel.mapel_code + '' + bab.bab_code + '' + 'undefined')
        this.loading = false
        this.$router.push('/item-bank/soal/' + mapel.mapel_code + '/' + bab.bab_code + '/undefined?v=true')
      }).catch(err =>{
        // console.log(err)
        this.loading = false
        this.sessionError = true
      })
    },
    setLastTopics(ids){
      if (sessionStorage.lastTopics) {
        var sessLastTopics = JSON.parse(sessionStorage.lastTopics)
        var identical = null
        // for(var i = 0; i < sessLastTopics.length; i++){
          var srcTopics = sessLastTopics.findIndex(function(element){
            return element.id === ids
          })
          if(srcTopics !== -1) {
            identical = sessLastTopics[srcTopics]
            sessLastTopics.splice(srcTopics, 1)
            sessLastTopics.push(identical)
            sessionStorage.lastTopics = JSON.stringify(sessLastTopics)
          } else {
            sessLastTopics.push({ 
              mapel: 
                {
                  mapel_code: this.selectedMapel.mapel_code, 
                  mapel_id: this.selectedMapel.mapel_id, 
                  mapel_name: this.selectedMapel.mapel_name,
                  mapel_picture: this.selectedMapel.mapel_picture
                },
              bab: {
                  bab_code: this.selectedBab.bab_code, 
                  bab_id: this.selectedBab.bab_id, 
                  bab_name: this.selectedBab.bab_name
                },
              subbab: this.selectedSubBab !== '' ? {
                  sub_bab_code: this.selectedSubBab.sub_bab_code, 
                  sub_bab_id: this.selectedSubBab.sub_bab_id, 
                  sub_bab_name: this.selectedSubBab.sub_bab_name                    
                } : '', 
                id: this.selectedMapel.mapel_code + '' + this.selectedBab.bab_code + '' + this.selectedSubBab.sub_bab_code
              })
            sessionStorage.lastTopics = JSON.stringify(sessLastTopics)
          }
        // }
      } else {
        sessionStorage.lastTopics = JSON.stringify([
          { 
            mapel: 
              {
                mapel_code: this.selectedMapel.mapel_code, 
                mapel_id: this.selectedMapel.mapel_id, 
                mapel_name: this.selectedMapel.mapel_name,
                mapel_picture: this.selectedMapel.mapel_picture
              },
            bab: {
                bab_code: this.selectedBab.bab_code, 
                bab_id: this.selectedBab.bab_id, 
                bab_name: this.selectedBab.bab_name
              },
            subbab: this.selectedSubBab !== '' ? {
                sub_bab_code: this.selectedSubBab.sub_bab_code, 
                sub_bab_id: this.selectedSubBab.sub_bab_id, 
                sub_bab_name: this.selectedSubBab.sub_bab_name                    
              } : '', 
              id: this.selectedMapel.mapel_code + '' + this.selectedBab.bab_code + '' + this.selectedSubBab.sub_bab_code
            }
        ])
      }
    },
  },
  mounted(){
    if(this.$route.query.sv) {
      this.$refs.searchvideo.triggerChildFunc()
    }
    if(localStorage.getItem('videoData')){
      var vid = JSON.parse(localStorage.getItem('videoData'))
       this.$store.commit('mutVideoMapel', vid[1])
       this.$store.commit('mutVideoBab', vid[0])
       this.toSoal()
       localStorage.removeItem('videoData')
    }
    this.loader = true
    this.fetchBab()
  }
}
</script>
